<template>
  <div class="">
    <div class="">
      <div class="dialog-header">
        <div class="image">
          <icon :type="'details'" />
        </div>
        <h1>Cash Summary</h1>
      </div>

      <div class="container-fluid data-container mw-1940">
        <main class="bd-main">
          <div class="row">
            <div class="col-12">
              <div class="d-none d-lg-block">
                <div class="vertical-flex">
                  <p class="mt-3">
                    Cash Summary gives you an overview of your projected ATO payments, loan repayments, and other expenses. Sinchii breaks this down making it easy to see where you can expect your money to go over the next financial year.
                  </p>
                  <img src="@/assets/images/forecasted-impacts.png" alt="Example Forecasted Payments" class="img-fluid form-center" />
                  <p class="mt-4">
                    To get started, enter your bank balance at the start of the current month (For Xero connected accounts, this is pulled automatically), and if you have any loans, make sure to add these in the Loans section. This will help Sinchii calculate your projected cash flow and give you a better understanding of your financial situation. You can change these settings at any time.
                  </p>
                  <img src="@/assets/images/bank-balance.png" alt="Bank Balance" class="img-fluid form-center" />
                  <p class="mt-5">
                    For more information about the cash summary and how to use Sinchii, click <a href="https://sinchii.com/knowledge-centre/cash-summary/how-to-complete-your-cash-summary/" target="_blank">here</a>.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
    <div class="mb-4">
      <div class="row justify-content-center pt-5">
        <div class="col-12 col-lg-5 text-center">
          <k-button class="btn btn-lg btn-secondary w-100" type="button" @click="close">Let's Begin</k-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import icon from "../Icon.vue";

export default {
  components: {
    icon
  },
  methods: {
    close() {
      this.$emit("onClose");
    }
  }
};

</script>
